import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';

@Component({
  selector: 'app-kyc-card-alert-apt',
  templateUrl: './kyc-card-alert-apt.component.html',
  styleUrls: ['./kyc-card-alert-apt.component.scss'],
})
export class KycCardAlertAPTComponent implements OnInit {
  isMobile = false;

  constructor(
    public dialogRef: MatDialogRef<KycCardAlertAPTComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    if (window.screen.width <= 768) {
      this.isMobile = true;
    }
  }
}
